import FiveUpLayoutFinal from 'lazy/layout.lazy/five-up.js';
import MapLayoutEntry from 'lazy/layout.lazy/map.js';
import { ComponentType } from 'react';
import { ILayoutRegistryProps } from './registry-layout-get.js';

/**
 * Webpack chunks layout structure
 * All layouts are loaded dynamically apart from homepage (map) and five-up (location page)
 * This is as these are the most popular layouts and will allow for a quicker page display time
 */
const getLayoutComponent = async <T>(layoutName: string): Promise<React.ComponentType<T> | null> => {
  switch (layoutName) {
    case 'five-up': {
      /** We want to prefetch this as it is used on most other pages */
      const fiveUp = { default: FiveUpLayoutFinal };
      return fiveUp.default as React.ComponentType<T>;
    }
    case 'map': {
      /* This is the default page on the homepage so we want to eager load this within main chunk */
      const map = { default: MapLayoutEntry };
      return map.default as React.ComponentType<T>;
    }
    case 'warnings-map': {
      const warningsMap = await import(
        /* webpackChunkName: "layout-warnings-map" */
        'lazy/layout.lazy/warnings-map.js'
      );
      return warningsMap.default as React.ComponentType<T>;
    }
    case 'not-found': {
      const notFound = await import(
        /* webpackChunkName: "layout-not-found" */
        'lazy/layout.lazy/not-found.js'
      );
      return notFound.default as React.ComponentType<T>;
    }
    case 'overlay': {
      const overlay = await import(
        /* webpackChunkName: "layout-overlay" */
        'lazy/layout.lazy/overlay.js'
      );
      return overlay.default as React.ComponentType<T>;
    }
    default:
      console.error(`Unable to find module ${layoutName}`);
      return null;
  }
};

export const getRawLayoutComponent = async (name: string): Promise<ComponentType<ILayoutRegistryProps> | null> => {
  try {
    const rawLayoutComponent = await getLayoutComponent<ILayoutRegistryProps>(name);
    if (
      !rawLayoutComponent ||
      (typeof rawLayoutComponent === 'object' && Object.keys(rawLayoutComponent).length === 0)
    ) {
      console.error(`Failed dynamic import request, Layout component does not exist`, name);
      return null;
    }
    return rawLayoutComponent as ComponentType<ILayoutRegistryProps>;
  } catch (e) {
    console.info(JSON.stringify(e));
    return null;
  }
};
